import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { ClienteGrupoEconomico } from '../cliente-grupo-economico';

@Injectable({
    providedIn: 'root'
})
export class ClienteGrupoEconomicoDuplicateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientegrupoeconomico`;
    }

    /** Duplica o grupo econômico */
    duplicate(id: number): Observable<ClienteGrupoEconomico> {
        return this.customHttp.get<ClienteGrupoEconomico>(`${this.pathApi}/${id}/duplicate`);
    }
}
